import React from 'react';
import { styled } from '@mui/material/styles';

const Container = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'flex-start',
  backgroundRepeat: 'no-repeat',
  position: 'relative',
  '@media screen and (max-width: 991px)': {
    backgroundSize: '250%',
    backgroundPosition: 'right 35% bottom 75%',
    height: '300px',
    margin: '20px 0 10px 0',
    padding: '10px 0 -30px 0',
  },
  '@media screen and (min-width: 993px)': {
    backgroundSize: '100%',
    backgroundPosition: 'right 10% bottom 60%',
    height: '500px',
    margin: '80px 0 100px 0',
    padding: '50px 0 -80px 0',
  },
});

const TextContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: '#133552',
  alignItems: 'left',
  position: 'relative',
  '@media screen and (max-width: 991px)': {
    marginLeft: '5px',
    width: '325px',
    height: '325px',
    padding: '5% 3%',
    '&:after': {
      borderBottom: 'solid 25px transparent',
      borderRight: 'solid 25px transparent',
      borderLeft: 'solid 25px #58c1b3',
      transform: 'translateX(-50%)',
      position: 'absolute',
      zIndex: -1,
      content: '""',
      top: '92.4%',
      left: '107.6%',
      height: 0,
      width: 0,
    },
  },
  '@media screen and (min-width: 993px)': {
    marginLeft: '-34%',
    width: '500px',
    height: '524px',
    padding: '125px 80px',
    '&:after': {
      borderBottom: 'solid 25px transparent',
      borderRight: 'solid 25px transparent',
      borderLeft: 'solid 25px #58c1b3',
      transform: 'translateX(-50%)',
      position: 'absolute',
      zIndex: -1,
      content: '""',
      top: '95.25%',
      left: '105%',
      height: 0,
      width: 0,
    },
  },
});

const Description = styled('div')(({ theme }) => ({
  color: theme.palette.common.white,
  fontWeight: 300,
  [theme.breakpoints.up('md')]: {
    fontSize: '1.325rem',
    lineHeight: '2.225rem',
  },
  [theme.breakpoints.down('md')]: {
    fontSize: '1.125rem',
    lineHeight: '2.025rem',
  },
}));

const BackgroundWithBlackBox = ({ module }) => {
  const { fields } = module;

  return (
    <Container
      style={{
        border: '1px solid ${theme.palette.common.black}',
        backgroundImage: `linear-gradient(rgba(${fields.backgroundColor}),rgba(${fields.backgroundColor})), url(${fields.backgroundImage.url})`,
      }}
    >
      <TextContainer>
        <Description>{fields.text}</Description>
      </TextContainer>
    </Container>
  );
};
export default BackgroundWithBlackBox;
